module.exports = __webpack_public_path__ + "BreatheAway-470d7e95e91d65cff95ef030ed992e12.png";